module.exports = ".target-completed {\n  font-size: 2em;\n  text-align: center;\n  margin-top: 7em;\n  color: var(--primaryColor); }\n\n.width75 {\n  max-width: 75% !important; }\n\n.mt-18 {\n  margin-top: 18px; }\n\n.notify-alert {\n  background-color: var(--alert);\n  color: var(--white); }\n\n.notify-warning {\n  background-color: var(--warning);\n  color: var(--black); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/notification/notification.component.scss
// module id = ./src/app/core/notification/notification.component.scss
// module chunks = main